import {PuiSelect} from "@portnet/ui";
import React from "react";

const AppSelect = React.forwardRef((props, ref) => {
  return <PuiSelect ref={ref} {...props} />;
});

export default AppSelect;
